import { xhr } from '../../../httpsnippet-lite/targets/javascript/xhr/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * js/xhr
 */
export const jsXhr = {
    target: 'js',
    client: 'xhr',
    title: 'XHR',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(xhr, request);
    },
};
